import React from 'react';
import { connect } from 'react-redux';
import { buildAction } from '../../actions/helpers';
import {
  setChosenPlan,
  subscribe,
  setCouponCode,
  getActiveSubscription,
  getPlanPrice,
} from '../../actions/plan';
import { setRuntimeVariable } from '../../actions/runtime';
import { signup, showLogin, showSignup, getStep } from '../../actions/user';
import {
  ONBOARDING_STEP,
  SET_PAYMENT_ERROR,
  SET_COUPON_ERROR,
} from '../../constants';
import Onboarding from '../../components/Onboarding';
import facebook from '../../lib/facebook';

function mapStateToProps(state) {
  return {
    step: getStep(state),
    chosenPlan: state.plan.chosenPlan,
    activePlan: state.plan.activePlan,
    couponCode: state.plan.couponCode,
    couponError: state.plan.couponError,
    paymentError: state.plan.paymentError,
    planSummary: state.plan.chosenSummary,
    registrationError: state.runtime.registrationError,
    registrationMessage: state.runtime.registrationMessage,
    loginError: state.runtime.loginError,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onRegister: (email, password) =>
      dispatch(signup(email, password)).then(() => {
        dispatch(setRuntimeVariable('newUser', true));
        return dispatch(
          setRuntimeVariable('onboardingStep', ONBOARDING_STEP.PLAN),
        );
      }),
    onGoToLogin: () => dispatch(showLogin()),
    onGoToRegister: () => dispatch(showSignup()),
    onAfterConfirmAccount: () =>
      dispatch(setRuntimeVariable('onboardingStep', ONBOARDING_STEP.PLAN)),
    onForgotPassword: () =>
      dispatch(
        setRuntimeVariable('onboardingStep', ONBOARDING_STEP.FORGOT_PASSWORD),
      ),
    onAfterLogin: () =>
      dispatch(getActiveSubscription()).then(() =>
        Promise.resolve(
          ownProps.onAfterLogin !== undefined
            ? ownProps.onAfterLogin()
            : undefined,
        ).then(() =>
          dispatch(
            setRuntimeVariable('onboardingStep', ONBOARDING_STEP.COMPLETE),
          ),
        ),
      ),
    onAfterSendResetCode: () =>
      dispatch(
        setRuntimeVariable('onboardingStep', ONBOARDING_STEP.RESET_PASSWORD),
      ),
    onAfterSetPassword: () =>
      dispatch(setRuntimeVariable('onboardingStep', ONBOARDING_STEP.COMPLETE)),
    onGoToPlan: () =>
      dispatch(setRuntimeVariable('onboardingStep', ONBOARDING_STEP.PLAN)),
    onChangePlan: plan => dispatch(setChosenPlan(plan)),
    onChangeCoupon: code => dispatch(setCouponCode(code)),
    onConfirmPlan: plan => {
      facebook.track('AddToCart');
      facebook.track('InitiateCheckout');
      dispatch(buildAction(SET_PAYMENT_ERROR, undefined));
      dispatch(buildAction(SET_COUPON_ERROR, undefined));
      return dispatch(setChosenPlan(plan)).then(() =>
        dispatch(setRuntimeVariable('onboardingStep', ONBOARDING_STEP.PAY)),
      );
    },
    onCreateSubscription: (stripeTokenId, plan, coupon) =>
      dispatch(subscribe(stripeTokenId, plan, coupon))
        .then(() => {
          facebook.track('AddPaymentInfo');
          facebook.track('Purchase', {
            value: getPlanPrice(plan.name),
            currency: 'USD',
          });
        })
        .then(() => dispatch(getActiveSubscription()))
        .then(() =>
          dispatch(
            setRuntimeVariable('onboardingStep', ONBOARDING_STEP.COMPLETE),
          ),
        )
        .catch(err => {
          dispatch(buildAction(SET_PAYMENT_ERROR, err.message));
          throw err;
        }),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Onboarding);



// WEBPACK FOOTER //
// ./src/containers/OnboardingContainer/OnboardingContainer.js